import { t } from "i18next";

function Banner({ rtl }) {
  return (
    <div className="zatca-banner" dir={rtl}>
      <img className="banner-icon" src="/img/E-receipt.webp" alt="" />
      <h3>{t("serv-zatca")}</h3>
      <p>{t("serv-zatca_text")}</p>
      <img className="banner-logo" src="/img/logo-g.png" alt="" />
    </div>
  );
}

export default Banner;
